import { PlacementSelector } from './PlacementSelector';
import { TemplateSelector } from './TemplateSelector';
import styles from './SelectSection.module.css';

const SelectSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.selectors}>
        <PlacementSelector />
        <TemplateSelector />
      </div>
    </section>
  );
};

export { SelectSection };
